import { BFFGateway, DateRange } from "sb-resp-lib";
import { datesQueryFactory } from "../../queries";
import { IGroupedSportsToDatesMapper } from "../../mapper";
import { IClock } from "../../../../common";
import { DatesModel } from "../../model";

export interface IDatesGateway {
    GetDates(timezone:number, sportId: string): Promise<DatesModel[]>
}

export class DatesGateway implements IDatesGateway {
    private readonly clock: IClock;
    private readonly gateway: BFFGateway;
    private readonly queryFactory: datesQueryFactory;
    private readonly mapper: IGroupedSportsToDatesMapper;
    private readonly timeRange: DateRange.TimeRangeEnum;

    constructor(gateway: BFFGateway, queryFactory: datesQueryFactory, mapper: IGroupedSportsToDatesMapper,
        clock: IClock, timeRange: DateRange.TimeRangeEnum)
    {
        this.gateway = gateway;
        this.queryFactory = queryFactory;
        this.mapper = mapper;
        this.clock = clock;
        this.timeRange = timeRange;
    }

    async GetDates(timezone:number, sportId: string) {
        const targetDay = this.clock.getBeginningOfTodayForTimeZone(timezone);
        const request = this.queryFactory(targetDay, this.timeRange, sportId);
        const response = await this.gateway.getSportsGroupedByDate(request);
        return this.mapper.getDates(response, targetDay, timezone);
    }
}